<template>
  
  <router-view/>
</template>

<style lang="scss"  src="./styles/styles.scss">

</style>
